var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgC = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 8",
  viewBox: "0 0 200 198.535"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "C_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200v198.535H0z",
  "data-name": "Rectangle 18"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7",
  style: {
    clipPath: "url(#C_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M100 0a40.437 40.437 0 0 0-40.42 40.42c0 28.839 25.066 41.6 32.808 62.992C76.969 93.011 64.206 76.377 40.42 76.377a40.42 40.42 0 0 0 0 80.84c24.9 0 37.828-18.734 54.593-28.872-4.232 18.468-11.192 43.955-20.984 62.705a5.086 5.086 0 0 0 5.14 7.4 179 179 0 0 1 41.726.045 5.084 5.084 0 0 0 5.137-7.394c-9.76-18.761-16.781-44.273-21.045-62.759 16.667 10.138 29.462 28.872 54.593 28.872a40.42 40.42 0 0 0 0-80.84c-23.688 0-36.614 16.929-52.231 27.3 7.612-21.457 33.071-34.022 33.071-63.255A40.416 40.416 0 0 0 100 0",
  "data-name": "Path 4"
}))));
export default SvgC;